import React, { useState, useRef, useEffect } from 'react';
import { X, Check, Loader2, AlertCircle, Heart, FileSignature, ExternalLink } from 'lucide-react';
import { Button } from './ui/button';
import { useLanguage } from '../contexts/LanguageContext';
import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;
const ZAPPY_URL = "https://pt.zappysoftware.com/m/iprbckamit";

const translations = {
  en: {
    title: 'Lifestyle Consultation',
    subtitle: 'Please complete this form before your appointment',
    confidential: 'Information from the answers below will be kept strictly confidential.',
    lifestyle: 'Your Lifestyle',
    lashesSection: 'LASHES & BROWS',
    handsSection: 'HANDS & NAILS',
    feetSection: 'FEET & TOENAILS',
    medicalHistory: 'Medical History',
    allergies: 'Allergies & Sensitivities',
    conditions: 'Medical Conditions',
    consent: 'Consent & Declaration',
    bodyLabel: 'BODY',
    healthyEating: 'Healthy Eating',
    drinkWater: 'Drink enough water',
    exerciseRegularly: 'Exercise Regularly',
    sleepWell: 'Sleep well',
    smoke: 'Smoke',
    consumeAlcohol: 'Consume Alcohol',
    faceLabel: 'FACE',
    regularMenstrual: 'Have regular menstrual cycle',
    sunBath: 'Usually get sun bath',
    hormonalAlterations: 'Have hormonal alterations',
    useSunscreen: 'Use sunscreen',
    onDiet: 'Are you on a diet',
    acidTreatments: 'Ever had acid treatments',
    wearContactLenses: 'Do you wear contact lenses?',
    lashAllergyHistory: 'Have you ever had an allergic reaction to lash glue or extensions?',
    recentEyeSurgery: 'Have you had eye surgery in the last 6 months?',
    browTreatments: 'Have you had any brow treatments (tinting, microblading, etc.)?',
    hadLashExtensions: 'Have you had lash extensions before?',
    eyeInfections: 'Do you currently have any eye infections or conditions?',
    sensitivEyes: 'Do you have sensitive eyes?',
    browAllergies: 'Any known allergies to brow products or henna?',
    nailConditions: 'Do you have any nail conditions (fungus, brittleness, etc.)?',
    nailAllergies: 'Any allergies to nail products?',
    recentHandInjury: 'Any recent hand injuries or wounds?',
    hadGelAcrylic: 'Have you had gel or acrylic nails before?',
    handSkinConditions: 'Do you have any skin conditions on your hands (eczema, psoriasis)?',
    footConditions: 'Do you have any foot conditions (fungus, calluses, corns)?',
    ingrownToenails: 'Do you suffer from ingrown toenails?',
    recentFootInjury: 'Any recent foot injuries or wounds?',
    diabeticFoot: 'Do you have diabetic foot or circulation problems?',
    footSkinConditions: 'Any skin conditions on your feet?',
    footSensitivity: 'Do you have sensitive feet or ticklish?',
    takesMedication: 'Do you take any kind of medication?',
    hadFacial: 'Have you ever had a facial?',
    invasiveTreatments: 'Do you usually do invasive treatments?',
    allergicTo: 'Are you allergic or intolerant to:',
    essentialOils: 'Essential oils',
    nuts: 'Nuts',
    heat: 'Heat',
    iodine: 'Iodine',
    clay: 'Clay',
    none: 'None',
    other: 'Other',
    pleaseSpecify: 'Please specify',
    surgicalHistory: 'Have you had a surgical procedure or been involved in an accident in the past year?',
    sufferFrom: 'Do you suffer from any of the following conditions?',
    diabetes: 'Diabetes',
    epilepsy: 'Epilepsy',
    skinAllergies: 'Skin allergies',
    kidneyLiver: 'Kidney/Liver Problems',
    highBloodPressure: 'High blood pressure',
    stress: 'Stress',
    varicoseVeins: 'Varicose veins',
    heartProblems: 'Heart Problems',
    lowBloodPressure: 'Low blood pressure',
    asthma: 'Asthma',
    muscleAches: 'Muscle Aches',
    backProblems: 'Back Problems',
    digestiveProblems: 'Digestive Problems',
    acceptConsent: 'I accept the terms and conditions',
    signature: 'Signature',
    clearSignature: 'Clear',
    date: 'Date',
    submit: 'Submit Consultation Form',
    submitting: 'Submitting...',
    success: 'Form Submitted Successfully!',
    successMsg: 'Thank you for completing the consultation form. You will now be redirected to Zappy to finalize your booking.',
    redirectingToZappy: 'Continue to Zappy',
    error: 'Error submitting form. Please try again.',
  },
  fr: {
    title: 'Consultation Lifestyle',
    subtitle: 'Veuillez remplir ce formulaire avant votre rendez-vous',
    confidential: 'Les informations issues des reponses ci-dessous seront strictement confidentielles.',
    lifestyle: 'Votre Mode de Vie',
    lashesSection: 'CILS & SOURCILS',
    handsSection: 'MAINS & ONGLES',
    feetSection: 'PIEDS & ONGLES DE PIEDS',
    medicalHistory: 'Antecedents Medicaux',
    allergies: 'Allergies & Sensibilites',
    conditions: 'Conditions Medicales',
    consent: 'Consentement & Declaration',
    bodyLabel: 'CORPS',
    healthyEating: 'Alimentation saine',
    drinkWater: 'Boire suffisamment d\'eau',
    exerciseRegularly: 'Faire de l\'exercice regulierement',
    sleepWell: 'Bien dormir',
    smoke: 'Fumer',
    consumeAlcohol: 'Consommer de l\'alcool',
    faceLabel: 'VISAGE',
    regularMenstrual: 'Cycle menstruel regulier',
    sunBath: 'Prendre des bains de soleil',
    hormonalAlterations: 'Avoir des alterations hormonales',
    useSunscreen: 'Utiliser de la creme solaire',
    onDiet: 'Etes-vous au regime',
    acidTreatments: 'Avez-vous deja eu des traitements acides',
    wearContactLenses: 'Portez-vous des lentilles de contact ?',
    lashAllergyHistory: 'Avez-vous deja eu une reaction allergique a la colle ou aux extensions ?',
    recentEyeSurgery: 'Avez-vous subi une chirurgie oculaire au cours des 6 derniers mois ?',
    browTreatments: 'Avez-vous eu des traitements des sourcils (teinture, microblading, etc.) ?',
    hadLashExtensions: 'Avez-vous deja eu des extensions de cils ?',
    eyeInfections: 'Avez-vous actuellement des infections ou problemes oculaires ?',
    sensitivEyes: 'Avez-vous les yeux sensibles ?',
    browAllergies: 'Des allergies connues aux produits pour sourcils ou au henne ?',
    nailConditions: 'Avez-vous des problemes d\'ongles (mycose, fragilite, etc.) ?',
    nailAllergies: 'Des allergies aux produits pour ongles ?',
    recentHandInjury: 'Des blessures recentes aux mains ?',
    hadGelAcrylic: 'Avez-vous deja eu des ongles en gel ou acrylique ?',
    handSkinConditions: 'Avez-vous des problemes de peau sur les mains (eczema, psoriasis) ?',
    footConditions: 'Avez-vous des problemes de pieds (mycose, callosites, cors) ?',
    ingrownToenails: 'Souffrez-vous d\'ongles incarnes ?',
    recentFootInjury: 'Des blessures recentes aux pieds ?',
    diabeticFoot: 'Avez-vous le pied diabetique ou des problemes de circulation ?',
    footSkinConditions: 'Des problemes de peau sur les pieds ?',
    footSensitivity: 'Avez-vous les pieds sensibles ou chatouilleux ?',
    takesMedication: 'Prenez-vous des medicaments ?',
    hadFacial: 'Avez-vous deja fait un soin du visage ?',
    invasiveTreatments: 'Faites-vous habituellement des traitements invasifs ?',
    allergicTo: 'Etes-vous allergique ou intolerant a :',
    essentialOils: 'Huiles essentielles',
    nuts: 'Noix',
    heat: 'Chaleur',
    iodine: 'Iode',
    clay: 'Argile',
    none: 'Aucun',
    other: 'Autre',
    pleaseSpecify: 'Veuillez preciser',
    surgicalHistory: 'Avez-vous subi une intervention chirurgicale ou ete implique dans un accident au cours de la derniere annee ?',
    sufferFrom: 'Souffrez-vous de l\'une des conditions suivantes ?',
    diabetes: 'Diabete',
    epilepsy: 'Epilepsie',
    skinAllergies: 'Allergies cutanees',
    kidneyLiver: 'Problemes renaux/hepatiques',
    highBloodPressure: 'Hypertension',
    stress: 'Stress',
    varicoseVeins: 'Varices',
    heartProblems: 'Problemes cardiaques',
    lowBloodPressure: 'Hypotension',
    asthma: 'Asthme',
    muscleAches: 'Douleurs musculaires',
    backProblems: 'Problemes de dos',
    digestiveProblems: 'Problemes digestifs',
    acceptConsent: 'J\'accepte les termes et conditions',
    signature: 'Signature',
    clearSignature: 'Effacer',
    date: 'Date',
    submit: 'Soumettre le Formulaire',
    submitting: 'Envoi en cours...',
    success: 'Formulaire Soumis avec Succes !',
    successMsg: 'Merci d\'avoir rempli le formulaire de consultation. Vous allez maintenant etre redirige vers Zappy pour finaliser votre reservation.',
    redirectingToZappy: 'Continuer vers Zappy',
    error: 'Erreur lors de la soumission. Veuillez reessayer.',
  },
  pt: {
    title: 'Consulta de Estilo de Vida',
    subtitle: 'Por favor complete este formulario antes da sua consulta',
    confidential: 'As informacoes das respostas abaixo serao mantidas estritamente confidenciais.',
    lifestyle: 'Seu Estilo de Vida',
    lashesSection: 'PESTANAS & SOBRANCELHAS',
    handsSection: 'MAOS & UNHAS',
    feetSection: 'PES & UNHAS DOS PES',
    medicalHistory: 'Historico Medico',
    allergies: 'Alergias e Sensibilidades',
    conditions: 'Condicoes Medicas',
    consent: 'Consentimento e Declaracao',
    bodyLabel: 'CORPO',
    healthyEating: 'Alimentacao saudavel',
    drinkWater: 'Beber agua suficiente',
    exerciseRegularly: 'Exercicio regular',
    sleepWell: 'Dormir bem',
    smoke: 'Fumar',
    consumeAlcohol: 'Consumir alcool',
    faceLabel: 'ROSTO',
    regularMenstrual: 'Ciclo menstrual regular',
    sunBath: 'Tomar banhos de sol',
    hormonalAlterations: 'Alteracoes hormonais',
    useSunscreen: 'Usar protetor solar',
    onDiet: 'Esta de dieta',
    acidTreatments: 'Ja fez tratamentos acidos',
    wearContactLenses: 'Usa lentes de contacto?',
    lashAllergyHistory: 'Ja teve reacao alergica a cola ou extensoes?',
    recentEyeSurgery: 'Fez cirurgia ocular nos ultimos 6 meses?',
    browTreatments: 'Ja fez tratamentos de sobrancelhas (coloracao, microblading, etc.)?',
    hadLashExtensions: 'Ja fez extensoes de pestanas antes?',
    eyeInfections: 'Tem alguma infecao ou problema ocular atualmente?',
    sensitivEyes: 'Tem olhos sensiveis?',
    browAllergies: 'Alguma alergia conhecida a produtos para sobrancelhas ou henna?',
    nailConditions: 'Tem problemas nas unhas (fungos, fragilidade, etc.)?',
    nailAllergies: 'Alguma alergia a produtos para unhas?',
    recentHandInjury: 'Alguma lesao recente nas maos?',
    hadGelAcrylic: 'Ja fez unhas de gel ou acrilico antes?',
    handSkinConditions: 'Tem problemas de pele nas maos (eczema, psoriase)?',
    footConditions: 'Tem problemas nos pes (fungos, calosidades, calos)?',
    ingrownToenails: 'Sofre de unhas encravadas?',
    recentFootInjury: 'Alguma lesao recente nos pes?',
    diabeticFoot: 'Tem pe diabetico ou problemas de circulacao?',
    footSkinConditions: 'Algum problema de pele nos pes?',
    footSensitivity: 'Tem pes sensiveis ou cocegas?',
    takesMedication: 'Toma algum tipo de medicacao?',
    hadFacial: 'Ja fez tratamento facial?',
    invasiveTreatments: 'Costuma fazer tratamentos invasivos?',
    allergicTo: 'E alergico ou intolerante a:',
    essentialOils: 'Oleos essenciais',
    nuts: 'Frutos secos',
    heat: 'Calor',
    iodine: 'Iodo',
    clay: 'Argila',
    none: 'Nenhum',
    other: 'Outro',
    pleaseSpecify: 'Por favor especifique',
    surgicalHistory: 'Teve algum procedimento cirurgico ou esteve envolvido num acidente no ultimo ano?',
    sufferFrom: 'Sofre de alguma das seguintes condicoes?',
    diabetes: 'Diabetes',
    epilepsy: 'Epilepsia',
    skinAllergies: 'Alergias de pele',
    kidneyLiver: 'Problemas renais/hepaticos',
    highBloodPressure: 'Tensao alta',
    stress: 'Stress',
    varicoseVeins: 'Varizes',
    heartProblems: 'Problemas cardiacos',
    lowBloodPressure: 'Tensao baixa',
    asthma: 'Asma',
    muscleAches: 'Dores musculares',
    backProblems: 'Problemas de costas',
    digestiveProblems: 'Problemas digestivos',
    acceptConsent: 'Aceito os termos e condicoes',
    signature: 'Assinatura',
    clearSignature: 'Limpar',
    date: 'Data',
    submit: 'Submeter Formulario',
    submitting: 'A enviar...',
    success: 'Formulario Submetido com Sucesso!',
    successMsg: 'Obrigado por completar o formulario de consulta. Sera agora redirecionado para o Zappy para finalizar a sua reserva.',
    redirectingToZappy: 'Continuar para Zappy',
    error: 'Erro ao submeter. Por favor tente novamente.',
  },
  de: {
    title: 'Lifestyle-Beratung',
    subtitle: 'Bitte fullen Sie dieses Formular vor Ihrem Termin aus',
    confidential: 'Die Informationen aus den folgenden Antworten werden streng vertraulich behandelt.',
    lifestyle: 'Ihr Lebensstil',
    lashesSection: 'WIMPERN & AUGENBRAUEN',
    handsSection: 'HANDE & NAGEL',
    feetSection: 'FUSSE & ZEHENNAGEL',
    medicalHistory: 'Krankengeschichte',
    allergies: 'Allergien & Empfindlichkeiten',
    conditions: 'Medizinische Bedingungen',
    consent: 'Einwilligung & Erklarung',
    bodyLabel: 'KORPER',
    healthyEating: 'Gesunde Ernahrung',
    drinkWater: 'Genug Wasser trinken',
    exerciseRegularly: 'Regelmasig Sport treiben',
    sleepWell: 'Gut schlafen',
    smoke: 'Rauchen',
    consumeAlcohol: 'Alkohol konsumieren',
    faceLabel: 'GESICHT',
    regularMenstrual: 'Regelmasiger Menstruationszyklus',
    sunBath: 'Sonnenbaden',
    hormonalAlterations: 'Hormonelle Veranderungen',
    useSunscreen: 'Sonnenschutz verwenden',
    onDiet: 'Sind Sie auf Diat',
    acidTreatments: 'Hatten Sie jemals Saurebehandlungen',
    wearContactLenses: 'Tragen Sie Kontaktlinsen?',
    lashAllergyHistory: 'Hatten Sie jemals allergische Reaktionen auf Wimpernkleber?',
    recentEyeSurgery: 'Hatten Sie in den letzten 6 Monaten eine Augenoperation?',
    browTreatments: 'Hatten Sie Augenbrauenbehandlungen (Farben, Microblading)?',
    hadLashExtensions: 'Hatten Sie schon Wimpernverlangerungen?',
    eyeInfections: 'Haben Sie derzeit Augeninfektionen?',
    sensitivEyes: 'Haben Sie empfindliche Augen?',
    browAllergies: 'Bekannte Allergien gegen Augenbrauenprodukte oder Henna?',
    nailConditions: 'Haben Sie Nagelprobleme (Pilz, Bruchigkeit)?',
    nailAllergies: 'Allergien gegen Nagelprodukte?',
    recentHandInjury: 'Kurzliche Handverletzungen?',
    hadGelAcrylic: 'Hatten Sie Gel- oder Acrylnagel?',
    handSkinConditions: 'Hautprobleme an den Handen (Ekzem, Psoriasis)?',
    footConditions: 'Haben Sie Fusprobleme (Pilz, Hornhaut)?',
    ingrownToenails: 'Eingewachsene Zehennagel?',
    recentFootInjury: 'Kurzliche Fusverletzungen?',
    diabeticFoot: 'Diabetischer Fus oder Durchblutungsprobleme?',
    footSkinConditions: 'Hautprobleme an den Fusen?',
    footSensitivity: 'Empfindliche oder kitzelige Fuse?',
    takesMedication: 'Nehmen Sie irgendwelche Medikamente?',
    hadFacial: 'Hatten Sie schon eine Gesichtsbehandlung?',
    invasiveTreatments: 'Machen Sie normalerweise invasive Behandlungen?',
    allergicTo: 'Sind Sie allergisch oder intolerant gegen:',
    essentialOils: 'Atherische Ole',
    nuts: 'Nusse',
    heat: 'Hitze',
    iodine: 'Jod',
    clay: 'Ton',
    none: 'Keine',
    other: 'Andere',
    pleaseSpecify: 'Bitte angeben',
    surgicalHistory: 'Hatten Sie im letzten Jahr einen chirurgischen Eingriff oder waren Sie in einen Unfall verwickelt?',
    sufferFrom: 'Leiden Sie unter einer der folgenden Erkrankungen?',
    diabetes: 'Diabetes',
    epilepsy: 'Epilepsie',
    skinAllergies: 'Hautallergien',
    kidneyLiver: 'Nieren-/Leberprobleme',
    highBloodPressure: 'Bluthochdruck',
    stress: 'Stress',
    varicoseVeins: 'Krampfadern',
    heartProblems: 'Herzprobleme',
    lowBloodPressure: 'Niedriger Blutdruck',
    asthma: 'Asthma',
    muscleAches: 'Muskelschmerzen',
    backProblems: 'Ruckenprobleme',
    digestiveProblems: 'Verdauungsprobleme',
    acceptConsent: 'Ich akzeptiere die Bedingungen',
    signature: 'Unterschrift',
    clearSignature: 'Loschen',
    date: 'Datum',
    submit: 'Formular absenden',
    submitting: 'Wird gesendet...',
    success: 'Formular erfolgreich gesendet!',
    successMsg: 'Vielen Dank fur das Ausfullen des Beratungsformulars. Sie werden jetzt zu Zappy weitergeleitet, um Ihre Buchung abzuschliesen.',
    redirectingToZappy: 'Weiter zu Zappy',
    error: 'Fehler beim Senden. Bitte versuchen Sie es erneut.',
  },
  es: {
    title: 'Consulta de Estilo de Vida',
    subtitle: 'Por favor complete este formulario antes de su cita',
    confidential: 'La informacion de las respuestas a continuacion se mantendra estrictamente confidencial.',
    lifestyle: 'Su Estilo de Vida',
    lashesSection: 'PESTANAS Y CEJAS',
    handsSection: 'MANOS Y UNAS',
    feetSection: 'PIES Y UNAS DE PIES',
    medicalHistory: 'Historial Medico',
    allergies: 'Alergias y Sensibilidades',
    conditions: 'Condiciones Medicas',
    consent: 'Consentimiento y Declaracion',
    bodyLabel: 'CUERPO',
    healthyEating: 'Alimentacion saludable',
    drinkWater: 'Beber suficiente agua',
    exerciseRegularly: 'Ejercicio regular',
    sleepWell: 'Dormir bien',
    smoke: 'Fumar',
    consumeAlcohol: 'Consumir alcohol',
    faceLabel: 'CARA',
    regularMenstrual: 'Ciclo menstrual regular',
    sunBath: 'Tomar banos de sol',
    hormonalAlterations: 'Alteraciones hormonales',
    useSunscreen: 'Usar protector solar',
    onDiet: 'Esta a dieta',
    acidTreatments: 'Ha tenido tratamientos acidos',
    wearContactLenses: 'Usa lentes de contacto?',
    lashAllergyHistory: 'Ha tenido reaccion alergica al pegamento de pestanas?',
    recentEyeSurgery: 'Ha tenido cirugia ocular en los ultimos 6 meses?',
    browTreatments: 'Ha tenido tratamientos de cejas (tinte, microblading)?',
    hadLashExtensions: 'Ha tenido extensiones de pestanas?',
    eyeInfections: 'Tiene infecciones oculares actualmente?',
    sensitivEyes: 'Tiene ojos sensibles?',
    browAllergies: 'Alergias conocidas a productos para cejas o henna?',
    nailConditions: 'Tiene problemas en las unas (hongos, fragilidad)?',
    nailAllergies: 'Alergias a productos para unas?',
    recentHandInjury: 'Lesiones recientes en las manos?',
    hadGelAcrylic: 'Ha tenido unas de gel o acrilico?',
    handSkinConditions: 'Problemas de piel en las manos (eczema, psoriasis)?',
    footConditions: 'Tiene problemas en los pies (hongos, callos)?',
    ingrownToenails: 'Unas encarnadas?',
    recentFootInjury: 'Lesiones recientes en los pies?',
    diabeticFoot: 'Pie diabetico o problemas de circulacion?',
    footSkinConditions: 'Problemas de piel en los pies?',
    footSensitivity: 'Tiene pies sensibles o con cosquillas?',
    takesMedication: 'Toma algun tipo de medicacion?',
    hadFacial: 'Ha tenido un tratamiento facial?',
    invasiveTreatments: 'Suele hacer tratamientos invasivos?',
    allergicTo: 'Es alergico o intolerante a:',
    essentialOils: 'Aceites esenciales',
    nuts: 'Frutos secos',
    heat: 'Calor',
    iodine: 'Yodo',
    clay: 'Arcilla',
    none: 'Ninguno',
    other: 'Otro',
    pleaseSpecify: 'Por favor especifique',
    surgicalHistory: 'Ha tenido un procedimiento quirurgico o estuvo involucrado en un accidente el ano pasado?',
    sufferFrom: 'Sufre de alguna de las siguientes condiciones?',
    diabetes: 'Diabetes',
    epilepsy: 'Epilepsia',
    skinAllergies: 'Alergias de piel',
    kidneyLiver: 'Problemas renales/hepaticos',
    highBloodPressure: 'Presion alta',
    stress: 'Estres',
    varicoseVeins: 'Varices',
    heartProblems: 'Problemas cardiacos',
    lowBloodPressure: 'Presion baja',
    asthma: 'Asma',
    muscleAches: 'Dolores musculares',
    backProblems: 'Problemas de espalda',
    digestiveProblems: 'Problemas digestivos',
    acceptConsent: 'Acepto los terminos y condiciones',
    signature: 'Firma',
    clearSignature: 'Borrar',
    date: 'Fecha',
    submit: 'Enviar Formulario',
    submitting: 'Enviando...',
    success: 'Formulario Enviado con Exito!',
    successMsg: 'Gracias por completar el formulario de consulta. Sera redirigido a Zappy para finalizar su reserva.',
    redirectingToZappy: 'Continuar a Zappy',
    error: 'Error al enviar. Por favor intente de nuevo.',
  }
};

const FormCheckbox = ({ checked, onChange, label, testId }) => (
  <label className="flex items-start gap-3 cursor-pointer group" data-testid={testId}>
    <div className="relative flex-shrink-0 mt-0.5">
      <input 
        type="checkbox" 
        checked={checked} 
        onChange={onChange} 
        className="w-4 h-4 border-2 border-kamit-brown/40 rounded appearance-none cursor-pointer checked:bg-kamit-gold checked:border-kamit-gold transition-colors"
      />
      {checked && (
        <Check className="absolute inset-0 w-4 h-4 text-white pointer-events-none p-0.5" />
      )}
    </div>
    <span className="text-kamit-brown/90 text-sm leading-tight group-hover:text-kamit-brown transition-colors">{label}</span>
  </label>
);

const SectionHeader = ({ icon, title }) => (
  <div className="flex items-center gap-2 mb-4 pb-2 border-b border-kamit-brown/15">
    <span className="text-lg">{icon}</span>
    <h3 className="font-semibold text-kamit-brown tracking-wide text-sm uppercase">{title}</h3>
  </div>
);

const ConsultationForm = ({ isOpen, onClose, booking, standalone = false }) => {
  const { language } = useLanguage();
  const t = translations[language] || translations.en;
  const canvasRef = useRef(null);
  const [isDrawing, setIsDrawing] = useState(false);
  const [submitting, setSubmitting] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  
  const [formData, setFormData] = useState({
    healthyEating: false,
    drinkWater: false,
    exerciseRegularly: false,
    sleepWell: false,
    smoke: false,
    consumeAlcohol: false,
    regularMenstrual: false,
    sunBath: false,
    hormonalAlterations: false,
    useSunscreen: false,
    onDiet: false,
    acidTreatments: false,
    wearContactLenses: false,
    lashAllergyHistory: false,
    recentEyeSurgery: false,
    browTreatments: false,
    hadLashExtensions: false,
    eyeInfections: false,
    sensitivEyes: false,
    browAllergies: false,
    nailConditions: false,
    nailAllergies: false,
    recentHandInjury: false,
    hadGelAcrylic: false,
    handSkinConditions: false,
    footConditions: false,
    ingrownToenails: false,
    recentFootInjury: false,
    diabeticFoot: false,
    footSkinConditions: false,
    footSensitivity: false,
    takesMedication: false,
    hadFacial: false,
    invasiveTreatments: false,
    allergies: [],
    allergiesOther: '',
    surgicalHistory: false,
    conditions: [],
    conditionsOther: '',
    consentAccepted: false,
    signedDate: new Date().toISOString().split('T')[0]
  });

  useEffect(() => {
    if (canvasRef.current && (isOpen || standalone)) {
      const canvas = canvasRef.current;
      const ctx = canvas.getContext('2d');
      ctx.fillStyle = '#ffffff';
      ctx.fillRect(0, 0, canvas.width, canvas.height);
      ctx.strokeStyle = '#5C3D2E';
      ctx.lineWidth = 2;
      ctx.lineCap = 'round';
    }
  }, [isOpen, standalone]);

  const startDrawing = (e) => {
    setIsDrawing(true);
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX || e.touches?.[0]?.clientX) - rect.left;
    const y = (e.clientY || e.touches?.[0]?.clientY) - rect.top;
    ctx.beginPath();
    ctx.moveTo(x, y);
  };

  const draw = (e) => {
    if (!isDrawing) return;
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    const rect = canvas.getBoundingClientRect();
    const x = (e.clientX || e.touches?.[0]?.clientX) - rect.left;
    const y = (e.clientY || e.touches?.[0]?.clientY) - rect.top;
    ctx.lineTo(x, y);
    ctx.stroke();
  };

  const stopDrawing = () => setIsDrawing(false);

  const clearSignature = () => {
    const canvas = canvasRef.current;
    const ctx = canvas.getContext('2d');
    ctx.fillStyle = '#ffffff';
    ctx.fillRect(0, 0, canvas.width, canvas.height);
  };

  const handleCheckboxChange = (field, value) => {
    if (field === 'allergies' || field === 'conditions') {
      setFormData(prev => {
        const arr = prev[field];
        if (arr.includes(value)) {
          return { ...prev, [field]: arr.filter(v => v !== value) };
        } else {
          return { ...prev, [field]: [...arr, value] };
        }
      });
    } else {
      setFormData(prev => ({ ...prev, [field]: !prev[field] }));
    }
  };

  const redirectToZappy = () => {
    window.open(ZAPPY_URL, '_blank');
    if (onClose) onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSubmitting(true);
    setError(null);

    try {
      const signatureData = canvasRef.current?.toDataURL('image/png');
      const payload = {
        booking_id: standalone ? 'standalone-' + Date.now() : booking?.id || 'direct',
        ...formData,
        signature_data: signatureData
      };

      await axios.post(`${API}/consultations`, payload);
      setSuccess(true);
    } catch (err) {
      console.error('Error submitting consultation:', err);
      setError(t.error);
    } finally {
      setSubmitting(false);
    }
  };

  if (!isOpen && !standalone) return null;

  const FormContent = () => (
    <div className="space-y-8">
      {/* Section 1: Your Lifestyle */}
      <section className="bg-white rounded-xl p-5 shadow-sm border border-kamit-brown/10">
        <SectionHeader icon={<Heart className="w-5 h-5 text-kamit-gold" />} title={t.lifestyle} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
          <div className="space-y-3">
            <h4 className="font-bold text-kamit-brown text-xs uppercase tracking-wider mb-3">{t.bodyLabel}</h4>
            {['healthyEating', 'drinkWater', 'exerciseRegularly', 'sleepWell', 'smoke', 'consumeAlcohol'].map((field) => (
              <FormCheckbox 
                key={field}
                checked={formData[field]} 
                onChange={() => handleCheckboxChange(field)} 
                label={t[field]}
                testId={`checkbox-${field}`}
              />
            ))}
          </div>
          <div className="space-y-3">
            <h4 className="font-bold text-kamit-brown text-xs uppercase tracking-wider mb-3">{t.faceLabel}</h4>
            {['regularMenstrual', 'sunBath', 'hormonalAlterations', 'useSunscreen', 'onDiet', 'acidTreatments'].map((field) => (
              <FormCheckbox 
                key={field}
                checked={formData[field]} 
                onChange={() => handleCheckboxChange(field)} 
                label={t[field]}
                testId={`checkbox-${field}`}
              />
            ))}
          </div>
        </div>
      </section>

      {/* Section 2: Lashes & Brows */}
      <section className="bg-white rounded-xl p-5 shadow-sm border border-kamit-brown/10">
        <SectionHeader icon="👁" title={t.lashesSection} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {['wearContactLenses', 'hadLashExtensions', 'lashAllergyHistory', 'eyeInfections', 'recentEyeSurgery', 'sensitivEyes', 'browTreatments', 'browAllergies'].map((field) => (
            <FormCheckbox 
              key={field}
              checked={formData[field]} 
              onChange={() => handleCheckboxChange(field)} 
              label={t[field]}
              testId={`checkbox-${field}`}
            />
          ))}
        </div>
      </section>

      {/* Section 3: Hands & Nails */}
      <section className="bg-white rounded-xl p-5 shadow-sm border border-kamit-brown/10">
        <SectionHeader icon="💅" title={t.handsSection} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {['nailConditions', 'hadGelAcrylic', 'nailAllergies', 'handSkinConditions', 'recentHandInjury'].map((field) => (
            <FormCheckbox 
              key={field}
              checked={formData[field]} 
              onChange={() => handleCheckboxChange(field)} 
              label={t[field]}
              testId={`checkbox-${field}`}
            />
          ))}
        </div>
      </section>

      {/* Section 4: Feet & Toenails */}
      <section className="bg-white rounded-xl p-5 shadow-sm border border-kamit-brown/10">
        <SectionHeader icon="🦶" title={t.feetSection} />
        <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
          {['footConditions', 'diabeticFoot', 'ingrownToenails', 'footSkinConditions', 'recentFootInjury', 'footSensitivity'].map((field) => (
            <FormCheckbox 
              key={field}
              checked={formData[field]} 
              onChange={() => handleCheckboxChange(field)} 
              label={t[field]}
              testId={`checkbox-${field}`}
            />
          ))}
        </div>
      </section>

      {/* Section 5: Medical History */}
      <section className="bg-white rounded-xl p-5 shadow-sm border border-kamit-brown/10">
        <SectionHeader icon="🩺" title={t.medicalHistory} />
        <div className="space-y-3">
          {['takesMedication', 'hadFacial', 'invasiveTreatments'].map((field) => (
            <FormCheckbox 
              key={field}
              checked={formData[field]} 
              onChange={() => handleCheckboxChange(field)} 
              label={t[field]}
              testId={`checkbox-${field}`}
            />
          ))}
        </div>
      </section>

      {/* Section 6: Allergies & Sensitivities */}
      <section className="bg-white rounded-xl p-5 shadow-sm border border-kamit-brown/10">
        <SectionHeader icon="⚠" title={t.allergies} />
        <p className="text-sm text-kamit-brown/80 mb-4">{t.allergicTo}</p>
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-6 gap-3 mb-4">
          {['essentialOils', 'nuts', 'heat', 'iodine', 'clay', 'none'].map((allergy) => (
            <FormCheckbox 
              key={allergy}
              checked={formData.allergies.includes(allergy)} 
              onChange={() => handleCheckboxChange('allergies', allergy)} 
              label={t[allergy]}
              testId={`checkbox-allergy-${allergy}`}
            />
          ))}
        </div>
        <div className="mb-4">
          <label className="block text-sm font-medium text-kamit-brown mb-1">{t.other}</label>
          <input 
            type="text" 
            value={formData.allergiesOther} 
            onChange={(e) => setFormData(prev => ({ ...prev, allergiesOther: e.target.value }))} 
            placeholder={t.pleaseSpecify} 
            className="w-full p-3 border border-kamit-brown/20 rounded-lg focus:ring-2 focus:ring-kamit-gold focus:border-transparent text-sm bg-white"
            data-testid="input-allergies-other"
          />
        </div>
        <div className="pt-3 border-t border-kamit-brown/10">
          <FormCheckbox 
            checked={formData.surgicalHistory} 
            onChange={() => handleCheckboxChange('surgicalHistory')} 
            label={t.surgicalHistory}
            testId="checkbox-surgical-history"
          />
        </div>
      </section>

      {/* Section 7: Medical Conditions */}
      <section className="bg-white rounded-xl p-5 shadow-sm border border-kamit-brown/10">
        <SectionHeader icon="🩻" title={t.conditions} />
        <p className="text-sm text-kamit-brown/80 mb-4">{t.sufferFrom}</p>
        <div className="grid grid-cols-2 md:grid-cols-3 gap-3 mb-4">
          {['diabetes', 'epilepsy', 'skinAllergies', 'kidneyLiver', 'highBloodPressure', 'stress', 'varicoseVeins', 'heartProblems', 'lowBloodPressure', 'asthma', 'muscleAches', 'backProblems', 'digestiveProblems'].map((condition) => (
            <FormCheckbox 
              key={condition}
              checked={formData.conditions.includes(condition)} 
              onChange={() => handleCheckboxChange('conditions', condition)} 
              label={t[condition]}
              testId={`checkbox-condition-${condition}`}
            />
          ))}
        </div>
        <div>
          <label className="block text-sm font-medium text-kamit-brown mb-1">{t.other}</label>
          <input 
            type="text" 
            value={formData.conditionsOther} 
            onChange={(e) => setFormData(prev => ({ ...prev, conditionsOther: e.target.value }))} 
            placeholder={t.pleaseSpecify} 
            className="w-full p-3 border border-kamit-brown/20 rounded-lg focus:ring-2 focus:ring-kamit-gold focus:border-transparent text-sm bg-white"
            data-testid="input-conditions-other"
          />
        </div>
      </section>

      {/* Section 8: Consent & Signature */}
      <section className="bg-white rounded-xl p-5 shadow-sm border border-kamit-brown/10">
        <SectionHeader icon={<FileSignature className="w-5 h-5 text-kamit-gold" />} title={t.consent} />
        <FormCheckbox 
          checked={formData.consentAccepted} 
          onChange={() => handleCheckboxChange('consentAccepted')} 
          label={t.acceptConsent + ' *'}
          testId="checkbox-consent"
        />
        <div className="mt-4">
          <label className="block text-sm font-medium text-kamit-brown mb-2">{t.signature} *</label>
          <div className="border-2 border-dashed border-kamit-brown/30 rounded-lg overflow-hidden bg-white">
            <canvas 
              ref={canvasRef} 
              width={400} 
              height={120} 
              className="w-full touch-none cursor-crosshair" 
              onMouseDown={startDrawing} 
              onMouseMove={draw} 
              onMouseUp={stopDrawing} 
              onMouseLeave={stopDrawing} 
              onTouchStart={startDrawing} 
              onTouchMove={draw} 
              onTouchEnd={stopDrawing}
              data-testid="signature-canvas"
            />
          </div>
          <button 
            type="button" 
            onClick={clearSignature} 
            className="mt-2 text-sm text-kamit-brown/60 hover:text-kamit-brown underline"
            data-testid="btn-clear-signature"
          >
            {t.clearSignature}
          </button>
        </div>
        <div className="mt-4">
          <label className="block text-sm font-medium text-kamit-brown mb-1">{t.date}</label>
          <input 
            type="date" 
            value={formData.signedDate} 
            onChange={(e) => setFormData(prev => ({ ...prev, signedDate: e.target.value }))} 
            className="w-full p-3 border border-kamit-brown/20 rounded-lg focus:ring-2 focus:ring-kamit-gold focus:border-transparent bg-white"
            data-testid="input-date"
            required 
          />
        </div>
      </section>

      {error && (
        <div className="bg-red-50 text-red-600 p-4 rounded-lg flex items-center gap-2" data-testid="error-message">
          <AlertCircle className="h-5 w-5 flex-shrink-0" />
          {error}
        </div>
      )}

      <Button 
        type="submit" 
        disabled={submitting || !formData.consentAccepted} 
        className="w-full bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full py-6 text-lg disabled:opacity-50 disabled:cursor-not-allowed transition-all"
        data-testid="btn-submit"
      >
        {submitting ? (
          <>
            <Loader2 className="mr-2 h-5 w-5 animate-spin" />
            {t.submitting}
          </>
        ) : (
          <>
            <Check className="mr-2 h-5 w-5" />
            {t.submit}
          </>
        )}
      </Button>
    </div>
  );

  const SuccessContent = () => (
    <div className="p-8 md:p-12 text-center bg-white rounded-2xl">
      <div className="w-20 h-20 bg-green-100 rounded-full flex items-center justify-center mx-auto mb-6">
        <Check className="h-10 w-10 text-green-600" />
      </div>
      <h3 className="text-2xl font-heading text-kamit-brown mb-3">{t.success}</h3>
      <p className="text-kamit-brown/70 mb-6">{t.successMsg}</p>
      <Button 
        onClick={redirectToZappy}
        className="bg-kamit-gold hover:bg-kamit-gold/90 text-kamit-dark rounded-full px-8 py-3"
        data-testid="btn-redirect-zappy"
      >
        <ExternalLink className="mr-2 h-5 w-5" />
        {t.redirectingToZappy}
      </Button>
    </div>
  );

  // Standalone mode
  if (standalone) {
    return (
      <div className="bg-kamit-beige/30 rounded-2xl overflow-hidden" data-testid="consultation-form-standalone">
        {success ? <SuccessContent /> : (
          <form onSubmit={handleSubmit} className="p-4 md:p-6">
            <FormContent />
          </form>
        )}
      </div>
    );
  }

  // Modal mode
  return (
    <div 
      className="fixed inset-0 bg-black/60 backdrop-blur-sm z-50 flex items-center justify-center p-2 md:p-4" 
      onClick={onClose}
      data-testid="consultation-form-modal-backdrop"
    >
      <div 
        className="bg-kamit-beige/95 rounded-2xl max-w-4xl w-full max-h-[95vh] overflow-y-auto shadow-2xl" 
        onClick={(e) => e.stopPropagation()} 
        data-testid="consultation-form-modal"
      >
        <div className="sticky top-0 bg-kamit-brown p-4 md:p-6 rounded-t-2xl z-10">
          <button 
            onClick={onClose} 
            className="absolute top-4 right-4 text-kamit-beige/80 hover:text-kamit-beige transition-colors"
            data-testid="btn-close-modal"
          >
            <X className="h-6 w-6" />
          </button>
          <div className="flex items-center gap-3">
            <img 
              src="https://customer-assets.emergentagent.com/job_beauty-wellness-spot/artifacts/y6uqcyxn_1683577696901.png" 
              alt="IPRBC KAMIT" 
              className="h-12 w-12 rounded-full bg-white p-1" 
            />
            <div>
              <h2 className="font-heading text-xl md:text-2xl text-kamit-beige">{t.title}</h2>
              <p className="text-kamit-beige/70 text-sm">{t.subtitle}</p>
            </div>
          </div>
        </div>
        {success ? (
          <div className="p-4">
            <SuccessContent />
          </div>
        ) : (
          <form onSubmit={handleSubmit} className="p-4 md:p-6">
            <FormContent />
          </form>
        )}
      </div>
    </div>
  );
};

export default ConsultationForm;
